import { render, staticRenderFns } from "./ModalRuleCheckViolationsContainer.vue?vue&type=template&id=f03c8f7c&scoped=true&"
import script from "./ModalRuleCheckViolationsContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalRuleCheckViolationsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03c8f7c",
  null
  
)

export default component.exports